import _ from "lodash";
import React from "react";
import { useIntl } from "react-intl";

export const AssistantPostProcessing = (props) => {
  const { values = [], changeValues } = props;
  const intl = useIntl();
  return (
    <div>
      {_.map(values, (elem, index) => {
        return (
          <div className="row mb-1" key={index}>
            <div className="col-10">
              <div className="row">
                
                <div className="col-4">
                  <input
                    type="string"
                    name="schemaName"
                    className="form-control"
                    placeholder={intl.formatMessage({
                      id: "OpenAI.Assistants.PostProcessing.schemaName",
                    })}
                    value={elem.schemaName || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { [target.name]: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
                <div className="col-4">
                  <input
                    type="string"
                    name="schemaMethod"
                    className="form-control"
                    placeholder={intl.formatMessage({
                      id: "OpenAI.Assistants.PostProcessing.schemaMethod",
                    })}
                    value={elem.schemaMethod || ""}
                    onChange={({ target }) => {
                      Object.assign(values[index], { [target.name]: target.value });
                      changeValues(values);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col text-right">
              <AssistantPostProcessing.RemoveButton {...props} index={index} />
            </div>
          </div>
        );
      })}
    </div>
  );
};

AssistantPostProcessing.AddButton = (props) => {
  const { values = [], changeValues } = props;
  const addValue = () => {
    changeValues(values.concat([{}]));
  };
  return (
    <button className={`btn btn-success ${props.className}`} onClick={addValue}>
      <i className="fa fa-plus" />
    </button>
  );
};

AssistantPostProcessing.RemoveButton = (props) => {
  const { values = [], changeValues } = props;
  const removeValue = () => {
    changeValues(values.filter((elem, index) => index !== props.index));
  };
  return (
    <button className={`btn btn-sm btn-danger`} onClick={removeValue}>
      <i className="fa fa-minus" />
    </button>
  );
};

export default AssistantPostProcessing;
